import React from 'react';
import { Star, Phone } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { AGENCY_PHONE, AGENCY_PHONE_HREF } from '../../lib/clientApi';

const BADGES = {
  paid: { label: 'Payée', cls: 'bg-[hsl(var(--brand-mint))] text-[hsl(var(--brand-ink))] border-border' },
  unpaid: { label: 'À régler', cls: 'bg-secondary text-foreground border-border' },
  overdue: { label: 'En retard', cls: 'bg-destructive/10 text-destructive border-destructive/20' },
  upcoming: { label: 'À venir', cls: 'bg-[hsl(var(--brand-sky))] text-[hsl(var(--brand-ink))] border-border' },
  in_progress: { label: 'En cours', cls: 'bg-secondary text-foreground border-border' },
  done: { label: 'Terminée', cls: 'bg-secondary text-foreground border-border' },
  open: { label: 'Ouvert', cls: 'bg-[hsl(var(--brand-sky))] text-[hsl(var(--brand-ink))] border-border' },
  resolved: { label: 'Résolu', cls: 'bg-[hsl(var(--brand-mint))] text-[hsl(var(--brand-ink))] border-border' },
};

export function StatusBadge({ state, label, testId }) {
  const b = BADGES[state] || BADGES.unpaid;
  return <Badge variant="outline" className={`${b.cls} text-xs font-semibold`} data-testid={testId}>{label || b.label}</Badge>;
}

/** Read-only stars (size 16 by default). */
export function Stars({ value = 0, size = 'h-4 w-4', testId }) {
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${value} sur 5`} data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= Math.round(value) ? 'fill-[hsl(var(--brand-apricot))] text-[hsl(var(--brand-apricot))]' : 'text-muted-foreground/40'}`} />
      ))}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, copy, action, testId }) {
  return (
    <div className="rounded-[var(--radius)] border border-dashed border-border bg-card/60 p-8 text-center" data-testid={testId}>
      {Icon && <Icon className="h-10 w-10 mx-auto text-muted-foreground/60 mb-3" />}
      <p className="text-base font-semibold">{title}</p>
      {copy && <p className="text-base text-muted-foreground mt-1 leading-relaxed">{copy}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}

export function ContactAgencyButton({ variant = 'outline', testId = 'client-contact-agency-button', className = '' }) {
  return (
    <Button asChild variant={variant} className={`h-11 ${className}`} data-testid={testId}>
      <a href={AGENCY_PHONE_HREF}><Phone className="h-4 w-4 mr-2" /> Contacter l'agence · {AGENCY_PHONE}</a>
    </Button>
  );
}
